<script setup lang="ts">
import { ref } from 'vue'
import { useShare } from '@/composables/useShare'

const props = defineProps<{
  roomCode: string
}>()

const { shareRoom, canShare } = useShare()
const copied = ref(false)

const handleShare = async () => {
  const success = await shareRoom(props.roomCode)
  
  if (success && !canShare) {
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000)
  }
}
</script>

<template>
  <button
    @click="handleShare"
    class="flex items-center gap-2 px-3 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-sm transition-colors"
  >
    <svg v-if="!copied" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="18" cy="5" r="3"></circle>
      <circle cx="6" cy="12" r="3"></circle>
      <circle cx="18" cy="19" r="3"></circle>
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-success-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
    <span>{{ copied ? 'Copied!' : 'Share' }}</span>
  </button>
</template>
